import config from '../config';

import { useLocation } from 'react-router-dom';

export async function makeRequest(url, requestArgs, contentType) {
  let headers = new Headers();
  let bearer = 'Bearer ' + config.getTokenLocalStorage();
  headers.append('Authorization', bearer);
  if (contentType) {
    headers.append('Content-Type', contentType);
  }
  let options = {
    headers: headers,
    ...requestArgs
  };
  const response = await fetch(url, options);
  const data = await response.json();
  return data;
}

// Source: https://gist.github.com/zentala/1e6f72438796d74531803cc3833c039c
// Usage:
// formatBytes(bytes,decimals)
// formatBytes(1024);       // 1 KB
// formatBytes('1024');     // 1 KB
// formatBytes(1234);       // 1.21 KB
// formatBytes(1234, 3);    // 1.205 KB
export function prettyBytes(bytes, decimals) {
  if (parseInt(bytes) === 0) return '0 Bytes';
  const k = 1024,
    dm = decimals || 2,
    sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
    i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

export function insertUrlParam(key, value) {
  if (window.history.pushState) {
    let searchParams = new URLSearchParams(window.location.search);
    searchParams.set(key, value);
    let newurl =
      window.location.protocol +
      '//' +
      window.location.host +
      window.location.pathname +
      '?' +
      searchParams.toString();
    // window.history.replaceState(null, null, newurl);
    window.history.pushState({ path: newurl }, '', newurl);
  }
}

export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function formatDatetime(datetime) {
  const dt = new Date(datetime);
  return dt.toLocaleString();
}

export function arraysToObject(keys, values) {
  return Object.assign({}, ...keys.map((key, i) => ({ [key]: values[i] })));
}

export const timestampToLocaleString = (ts) => {
  const dateObject = new Date(Date.parse(ts));
  return dateObject.toLocaleString();
};

export function objectToArray(data) {
  return Object.keys(data).map((key) => ({
    name: key,
    value: data[key]
  }));
}

export function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export const getMonthDateYear = (datetime) => {
  const dt = new Date(datetime);
  const month = dt.getUTCMonth() + 1;
  const date = dt.getUTCDate();
  const year = String(dt.getUTCFullYear()).slice(2, 4);
  return `${month}-${date}-${year}`;
};

export const getDayMonthDateYear = (datetime) => {
  const dt = new Date(datetime);
  const day = config.dayNames[dt.getUTCDay()];
  const month = config.monthNames[dt.getUTCMonth()];
  const date = dt.getUTCDate();
  const year = dt.getUTCFullYear();
  return `${day}, ${month} ${date}, ${year}`;
};
